module.exports = __webpack_public_path__ + "8ff6ffa7b.png";